import { defineMessages } from 'react-intl-next';

export default defineMessages({
	teamPickerPlaceholder: {
		id: 'team-selector.team-picker.placeholder',
		defaultMessage: 'Search and add teams',
		description: 'Placeholder displayed on the team picker input field.',
	},
});
